
import React from "react";
import { Card } from "@/components/ui/card";

interface GeneralSettingsProps {
  blockTitle: string;
  onUpdateTitle: (value: string) => void;
}

const GeneralSettings: React.FC<GeneralSettingsProps> = ({
  blockTitle,
  onUpdateTitle
}) => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">הגדרות כלליות</h3>
      <div className="space-y-4">
        <div>
          <label className="block mb-2">כותרת הבלוק</label>
          <input
            type="text"
            value={blockTitle}
            onChange={(e) => onUpdateTitle(e.target.value)}
            className="w-full p-2 border rounded"
          />
        </div>
      </div>
    </Card>
  );
};

export default GeneralSettings;
